import { Component } from '@angular/core';
import { DataHelper } from '@helpers/data.helper';
import { TranslateService } from '@services/translate.service';
import { ApiService } from '@services/api.service';
import { DimmerService } from '@services/dimmer.service';

@Component({
  selector: 'birthdate-bonus-component',
  templateUrl: './birthdateBonus.component.html',
})
export class BirthdateBonusComponent {
  constructor(public _DataHelper: DataHelper, private _TranslateService: TranslateService, private _ApiService: ApiService, public _DimmerService: DimmerService) {}
  public closeBirthdayModal() {
    this._DimmerService.clearActiveModalId();
  }
}
